module.exports = __webpack_public_path__ + "img/Warrior-gnome-f-70.9a25f6cf.gif";